import { render, staticRenderFns } from "./SummarySidebar.vue?vue&type=template&id=1ddb4274&scoped=true&"
import script from "./SummarySidebar.vue?vue&type=script&lang=js&"
export * from "./SummarySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddb4274",
  null
  
)

export default component.exports